import { Box, Typography } from '@mui/material'
import React, { forwardRef } from 'react'
import DetailCalculation from 'module/payroll/global-components/DetailCalculation'
import AdxButton from 'components/custom/AdxButton'

const DetailSummary = forwardRef((props, _ref) => {
  const { data, stateChanges, time_id, onCalculate, onEditStatutory, isActionDisabled } = props

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      padding={4}
      sx={{
        width: 'calc(100vw * 1 / 3)',
        height: '100vh',
        overflow: 'auto',
        backgroundColor: 'gray-background.main',
      }}
    >
      <Box>
        <Typography variant="h4" fontWeight={600}>
          Summary
        </Typography>
        {data && (
          <DetailCalculation
            data={data}
            time_id={time_id}
            editPage={true}
            onEditStatutory={onEditStatutory}
          />
        )}
      </Box>
      {data &&
        (stateChanges ? (
          <Box display="flex" flexDirection="column" justifyContent="flex-start">
            <Typography variant="body2">
              Some changes have been made for the selected employee. Please click button below to
              re-calculate.
            </Typography>
            <AdxButton
              variant={'outlined'}
              sx={{ width: 1, mt: 1, boxSizing: 'border-box' }}
              id="calculationButton"
              disabled={isActionDisabled}
              onClick={onCalculate}
            >
              Calculate
            </AdxButton>
          </Box>
        ) : (
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h4" color="light-gray-text.main">
              Net pay
            </Typography>
            <Typography
              variant="h4"
              color={data.status === 1 && 'yellow-01.main'}
            >{`RM ${data.salary?.nett}`}</Typography>
          </Box>
        ))}
    </Box>
  )
})

export default DetailSummary
